module.exports = __webpack_public_path__ + "img/20200403144138780.3de47777.png";